/**
 * Homepage A/B: AI “coming soon” banner copy.
 * Destination: `/ai-coming-soon` (HubSpot interest form).
 *
 * Default `/` has no AI banner. Challengers v1–v5 are served via Cloudflare
 * rewrite onto `/` and each carry a banner that links with `?v=<id>` so form
 * answers self-attribute without depending on GA/GTM.
 */
export const AI_BANNER_LINK_BASE = "/ai-coming-soon"

/**
 * Variant travels in the URL so form answers attribute without GA/GTM.
 * @param {string} variantId
 */
export function getAiBannerLink(variantId) {
  return `${AI_BANNER_LINK_BASE}?v=${encodeURIComponent(variantId)}`
}

/** @typedef {{ id: string, label: string, copy: string, assetPath: string }} AiBannerVariant */

/** @type {Record<string, AiBannerVariant>} */
export const AI_BANNER_VARIANTS = {
  v1: {
    id: "v1",
    label: "AI Chief of Staff",
    copy: "Coming soon. The AI Chief of Staff for your business.",
    assetPath: "/v1",
  },
  v2: {
    id: "v2",
    label: "AI Business Advisor",
    copy: "Coming soon. Your new AI Business Advisor.",
    assetPath: "/v2",
  },
  v3: {
    id: "v3",
    label: "AI Operating Partner",
    copy: "Coming soon. The AI Operating Partner for your business.",
    assetPath: "/v3",
  },
  v4: {
    id: "v4",
    label: "AI Business Assistant",
    copy: "Coming soon. Your new AI Business Assistant.",
    assetPath: "/v4",
  },
  v5: {
    id: "v5",
    label: "AI Analyst",
    copy: "Coming soon. The AI Analyst for your business.",
    assetPath: "/v5",
  },
}

export const AI_BANNER_VARIANT_IDS = Object.keys(AI_BANNER_VARIANTS)

export const HOME_AI_BANNER_EXPERIMENT_ID = "homepage-ai-banner-2026-08"
